import { useMemo } from 'react'
import { ProjectTranslations } from '../../../api/projects/types'
import settings from '../../../api/settings/hooks'
import { APPLICATION_SETTINGS } from '../../../common/constants'
import { projectDescriptionInputs } from '../../../common/forms/projects/inputs'
import { projectDescriptionValidation } from '../../../common/forms/projects/validation'
import { addRequiredValidation } from '../../../utils/formUtils/forms'
import { Field, FieldGroup } from '../../../utils/formUtils/types'

export const useProjectDescriptionFormConfig = (data?: ProjectTranslations) => {
    const { data: availableTranslationLanguages = [] } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.availableTranslationLanguages,
    })

    const currentLang = localStorage.getItem('i18nextLng')

    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            lang: currentLang,
            languages: availableTranslationLanguages.map((lang) => lang.abbreviation),
        }),
        [currentLang, availableTranslationLanguages]
    )

    return useMemo(() => {
        const descriptionInputs = projectDescriptionInputs(appSettings)
        const descriptionValidationConfig = projectDescriptionValidation(data, appSettings)

        const flattenedDescriptionInputs = [descriptionInputs.sideForm, descriptionInputs.mainForm].flat(Infinity).filter(Boolean) as (
            | Field
            | FieldGroup
        )[]

        addRequiredValidation(descriptionValidationConfig.validationSchema.fields, flattenedDescriptionInputs)

        return {
            descriptionInputs,
            descriptionValidationConfig,
        }
    }, [data, appSettings])
}
